import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import React, { useState } from "react";
import { isic_get_card_microservice } from "../store/api";
import CachedImage from "./CachedImage";
import { Announcement } from "../store/slices/announcementsSlice";
import { Discount } from "../store/slices/discountsSlice";
import AnnouncementBanner from "./AnnouncementBanner";
import { Modal, Portal } from "react-native-paper";
import DiscountBanner from "./DiscountBanner";
interface BannerImageProps {
  bannerImageId: string;
  type: "announcements" | "discounts";
  data: Discount | Announcement;
}
const BannerImage = ({
  bannerImageId,
  type = "discounts",
  data,
}: BannerImageProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  let pathUrl = `${isic_get_card_microservice}/users/${
    type === "announcements" ? "announcements/image/" : "discounts/"
  }`;
  const handleClick = () => {
    setModalOpen(!modalOpen);
  };
  const id =
    type === "discounts" ? (data as Discount).id : (data as Announcement)._id;

  return (
    <>
      <TouchableOpacity onPress={handleClick} style={styles.root}>
        <CachedImage
          cacheKey={bannerImageId}
          source={{ uri: pathUrl + bannerImageId }}
          style={styles.bannerImage}

        />
      </TouchableOpacity>
      <Portal>
        <Modal
          visible={modalOpen}
          onDismiss={() => setModalOpen(!modalOpen)}
          contentContainerStyle={styles.modalContainer}
        >
          {type === "announcements" ? (
            <AnnouncementBanner
              close={handleClick}
              bannerSource={pathUrl + (data as Announcement).screen_image_id}
            />
          ) : (
            <DiscountBanner info={data as Discount} close={handleClick} />
          )}
        </Modal>
      </Portal>
    </>
  );
};

export default BannerImage;

const styles = StyleSheet.create({
  root: {
    borderRadius: 17,
    paddingHorizontal: 10,
  },

  bannerImage: {
    width: 288,
    height: 140,
    borderRadius: 17,
  },
  modalContainer: {},
});
